import { render, staticRenderFns } from "./DebugComponent.vue?vue&type=template&id=27ccea46&"
import script from "./DebugComponent.vue?vue&type=script&lang=ts&"
export * from "./DebugComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports